module.exports = __webpack_public_path__ + "static/media/xz03_grey.2a5ac68d.png";